export const TOGGLE_SIDE_DRAWER = "TOGGLE_SIDE_DRAWER";
export const OAUTH_SHOW_AUTH_WINDOW = "OAUTH_SHOW_AUTH_WINDOW";
export const SET_APPBAR_TITLE = "SET_APPBAR_TITLE";
export const SET_LANGUAGE = "SET_LANGUAGE";
export const SET_DRAWER_TEXT_WIDTH = "SET_DRAWER_TEXT_WIDTH";
export const SET_DRAWER_WIDTH = "SET_DRAWER_WIDTH";

export const setShowSideDrawer = sideDrawerOpen => ({
  type: TOGGLE_SIDE_DRAWER,
  sideDrawerOpen,
});

export const showAuthWindow = showOAuthWindow => ({
  type: OAUTH_SHOW_AUTH_WINDOW,
  showOAuthWindow,
});

export const setAppbarTitle = title => ({
  type: SET_APPBAR_TITLE,
  title,
});

export const setLanguage = language => ({
  type: SET_LANGUAGE,
  language,
});

export const setDrawerTextWidth = width => ({
  type: SET_DRAWER_TEXT_WIDTH,
  width,
});

export const setDrawerWidth = width => ({
  type: SET_DRAWER_WIDTH,
  width,
});
